import { withInstall, withNoopInstall } from '@bigin/utils'
import Table from './src/table.vue'
import TableColumn from './src/tableColumn'

export const BTable = withInstall(Table, {
  TableColumn,
})
export default BTable
export const BTableColumn = withNoopInstall(TableColumn)

export type {
  SummaryMethod,
  Table,
  TableProps,
  TableRefs,
  ColumnCls,
  ColumnStyle,
  TreeNode,
  RenderRowData,
  Sort,
  Filter,
  TableConfigContext,
} from './src/table/defaults'
